import React, { useState } from 'react';
import { Button } from './button';
import { Input } from './input';
import { Field, Label, ErrorMessage } from './fieldset';
import { Heading } from './heading';
import { Text } from './text';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError('Por favor ingresa tu dirección de email.');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Si el email existe, se ha enviado un enlace para restablecer tu contraseña.');
    } catch (err) {
      setError('Error al enviar el email de recuperación. Por favor intenta más tarde.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center"
      style={{
        background: 'linear-gradient(160deg, #1b4d2e 0%, #0d1f17 100%)',
      }}
    >
      <div className="w-full max-w-md rounded-xl border border-zinc-200 bg-white p-6 shadow-sm dark:border-zinc-700/60 dark:bg-zinc-800/50">
        <img
          src="/logoH2.png"
          alt="Logo"
          className="mx-auto mb-4 h-auto"
        />
        <Heading level={1} className="text-center">
          Recuperar Contraseña
        </Heading>
        <Text className="mt-2 text-center">
          Ingresa tu email para recibir un enlace de recuperación.
        </Text>
        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {message && (
            <Text className="rounded-md bg-green-50 p-3 text-sm !text-green-700 dark:bg-green-900/20 dark:!text-green-400">
              {message}
            </Text>
          )}
          <Field>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ingresa tu email"
              required
              disabled={loading}
            />
          </Field>
          <Button
            type="submit"
            color="dark"
            className="w-full"
            style={{ '--btn-bg': '#1b4d2e', '--btn-border': '#163f25', '--btn-hover-overlay': 'rgba(255,255,255,0.10)' }}
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
          </Button>
        </form>
        <div className="mt-4 text-center">
          <Link
            to="/login"
            className="text-sm hover:underline"
            style={{ color: '#1b4d2e' }}
          >
            Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
